import { useState } from "react"
import ModalFirma from "../../components/ModalFirma/ModalFirma"
import css from './Firmas.module.css'
import { Button } from "@mui/material"


const Firmas = ({ firmaAlumno, firmaTutor, necesitaFirmaTutor, setFirmaAlumno, setFirmaTutor })=> {

  const hasFirmaAlumno = !!firmaAlumno
  const hasFirmaTutor = !!firmaTutor

  const [visibleModal, setVisibleModal] = useState('')

  const handleCloseModal = () => setVisibleModal('')

  const handleOpenModal = (type) => setVisibleModal(type)

  const handleFirma = (dataUrl) => {
    if (visibleModal === 'alumno') setFirmaAlumno(dataUrl)
    if (visibleModal === 'tutor') setFirmaTutor(dataUrl)
    handleCloseModal()
  }

  return (
    <div className={css.firmas}>
      <div className={css.actions}>
        <Button
          color="secondary"
          className={css.firma} 
          variant={hasFirmaAlumno ? 'contained' : 'outlined'}
          startIcon={hasFirmaAlumno && <i className='material-icons'>check</i>}
          disabled={hasFirmaAlumno}
          onClick={()=> handleOpenModal('alumno')}

        >
          Firma del alumno
        </Button>
        {necesitaFirmaTutor && (
          <Button
            color="secondary"
            className={css.firma} 
            variant={hasFirmaTutor ? 'contained' : 'outlined'}
            startIcon={hasFirmaTutor && <i className='material-icons'>check</i>}
            disabled={hasFirmaTutor}
            onClick={()=> handleOpenModal('tutor')}
          >
            Firma del tutor
          </Button>
        )}
      </div>
      <ModalFirma
        open={Boolean(visibleModal)} 
        onClose={handleCloseModal} 
        onSubmit={handleFirma} 
      />
    </div>
  )
}

export default Firmas